export const inputStyles = (
  hasError: boolean,
  controlStyle: string,
  errorStyle: string
) => (hasError ? `${controlStyle} ${errorStyle}` : controlStyle);

export default {};
